module.exports = __webpack_public_path__ + "img/high.942b1c98.svg";